import { render, staticRenderFns } from "./EquiposVerDetalle.vue?vue&type=template&id=2a906b62&"
import script from "./EquiposVerDetalle.vue?vue&type=script&lang=ts&"
export * from "./EquiposVerDetalle.vue?vue&type=script&lang=ts&"
import style0 from "./EquiposVerDetalle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2a906b62', component.options)
    } else {
      api.reload('2a906b62', component.options)
    }
    module.hot.accept("./EquiposVerDetalle.vue?vue&type=template&id=2a906b62&", function () {
      api.rerender('2a906b62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Equipos/EquiposVerDetalle.vue"
export default component.exports